import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService, ShowHideInput, PatientService, User } from '../../shared';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from '../../shared/config/app-config';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  templateUrl: 'upload.component.html',
  styleUrls: ['../style.component.css']


})

export class UploadComponent implements OnInit {
  public data: Object;
  apiurl = environment.api_url;
  params: any;
  defaultimg: boolean = true;
  terms: number = 0;
  careimagearr;
  modalRef: BsModalRef;
  // public imageURL:string;
  public currentUser: User;
  caredataimg: any;
  patimage: any = {};
  public carepath: any = {};
  public myobj1: any = {};
  constructor(

    private activeroute: ActivatedRoute,
    private userService: UserService,
    private routers: Router,
    private patientservice: PatientService,
    private modalService: BsModalService,
    private toast: ToastrService,
  ) {

  }




  ngOnInit() {

    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
      }
    )

    //   if(this.currentUser.item.hostModel=="CLOUD")
    //   this.imageURL = environment.cloudeImageURL;
    // else   
    //   this.imageURL = environment.vmImageURL;

    // ////console.log("id",this.params.patid)
    this.patientservice
      .getimageid(window.localStorage['randId'])
      .subscribe(
        data => {
          this.patimage = data;
          //////console.log(this.patimage)
        }
      );

    //  alert(JSON.parse( window.localStorage['pwd']))

    if (window.localStorage['pwd']) {
      this.carepath = JSON.parse(window.localStorage['pwd']);
      this.myobj1 = JSON.stringify(this.carepath);
      // ////console.log("care",this.carepath.userFnLn)
    }
    else {
      this.routers.navigate([`/login`])
    }

  }

  addimgurl(event, passimage) {
    this.defaultimg = false;
    //////console.log("hide" + this.defaultimg);
    let reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (events: any) => {
      this.caredataimg = events.currentTarget.result; // base64      
      //////console.log(event.target.files[0]);
      this.careimagearr = [{
        filename: event.target.files[0].name,
        filetype: event.target.files[0].type,
        value: events.currentTarget.result.split(',')[1]
      }];
      //////console.log(this.careimagearr);
      /* setTimeout(() => {
         this.addimage(passimage);
       }, 1000)  */

    }
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }


  addimage() {

    if (this.defaultimg) {
      this.routers.navigate([`/profilepage`])
    }
    else {

      let uploadimage = this.careimagearr;
      if (this.careimagearr == undefined) {
        uploadimage = [{}];
      }

      let imagevalue = {
        "loginUserName": this.params.email,
        "uploadimage": uploadimage,

      }

      //////console.log("image", imagevalue);


      this.patientservice
        .uploadimage(imagevalue)
        .subscribe(
          data => {


            //////console.log(data);  

            if (data) {

              this.routers.navigate([`/profilepage`])
              //this.modalRef = this.modalService.show(sucessda, {class: 'modal-sm'});

            } else {
              this.toast.error(this.userService.translateText('patient_portal.display_messages.image_upload_fail'))
              //////console.log("Image Upload Failed")
              // this.resdata = "Image Upload Failed";
              // this.modalRef = this.modalService.show(passimage, {class: 'modal-sm'});    
            }


          }
        );
    }

  }

}




